// Libs
import createReducer from 'fc-utils/createReducer'
import _reduce from 'lodash/reduce'

// Initial State
import initialState from './initialState'

// Action types
import { CREATE_REQUEST, UPDATE_REQUEST, DELETE_REQUEST, PROP_REQUEST_ID } from './constants'

function storeRequests (state, request) {
  return {
    ...state,
    requests: {
      ...state.requests,
      [request[PROP_REQUEST_ID]]: {...request},
    },
  }
}

function updateRequests (state, request) {
  return {
    ...state,
    requests: {
      ...state.requests,
      [request[PROP_REQUEST_ID]]: {...request},
    },
  }
}

function deleteRequest (state, requestId) {
  return {
    ...state,
    requests: _reduce(state.requests, (acc, request) => {
      if (request[requestId]) {
        return acc
      }
      return {...acc, ...request}
    }, {}),
  }
}

export const reducerMap = {
  [CREATE_REQUEST]: storeRequests,
  [UPDATE_REQUEST]: updateRequests,
  [DELETE_REQUEST]: deleteRequest,
}

export default createReducer(initialState, reducerMap)
